import { deleteRequest, get, post } from './_defaults/fetch.js';

export const getFolders = async ({params, config}) => get('/folders', {params, ...config});
export const getFolder = async ({id, params, config}) => get(`/folders/${id}`, {params, ...config});
export const createFolder = async ({data, config}) => post('/folders', data, config);
export const updateFolder = async ({id, data, config}) => post(`/folders/${id}`, data, config);
export const deleteFolder = async ({id, config}) => deleteRequest(`/folders/${id}`, null, config);
    
export const createFolderDocument = ({id, data, config}) => post(`/folders/${id}/documents`, data, config);

export const createFolderArea = ({id, data, config}) => post(`/folders/${id}/areas`, data, config);
export const deleteFolderArea = ({id, areaId, config}) => deleteRequest(`/folders/${id}/areas/${areaId}`, null, config);

export const createFolderOffice = ({id, data, config}) => post(`/folders/${id}/offices`, data, config);
export const deleteFolderOffice = ({id, officeId, config}) => deleteRequest(`/folders/${id}/offices/${officeId}`, null, config);

export const createFolderTag = ({id, data, config}) => post(`/folders/${id}/tags`, data, config);
export const deleteFolderTag = ({id, tagId, config}) => deleteRequest(`/folders/${id}/tags/${tagId}`, null, config);

export const createFolderRule = ({id, data, config}) => post(`/folders/${id}/rules`, data, config);
export const deleteFolderRule = ({id, ruleId, config}) => deleteRequest(`/folders/${id}/rules/${ruleId}`, null, config);